import React from "react";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";

const SkeletonList = ({
    rows = 1,
    height = 52,
    borderRadius = "0.75rem",
    className = "",
}) => {
    return (
        <div className={className}>
            {[...Array(rows)].map((_, index) => (
                <Skeleton
                    key={index}
                    height={height}
                    borderRadius={borderRadius}
                    baseColor="#d1d5db"
                    highlightColor="#f3f4f6"
                />
            ))}
        </div>
    );
};

export default SkeletonList;